// extracted by mini-css-extract-plugin
export default {"buttons":"DeleteProductProviderModal_buttons__Kmks7","errorMessage":"DeleteProductProviderModal_errorMessage__MITz2"};